// extracted by mini-css-extract-plugin
export default {"toggle-form-button":"styles_toggle-form-button__hKea4"};